import { lifecycle, withState, compose } from 'recompose';
import App from './App';
import conf from '../conf';
import callApi, { getStudio } from '../service/data';

// url API geocoding
const { sensorUrl } = conf;

// get data from token client and add lat and lng for each item
const getDataWithSensor = (dataStudio) => {
  const promises = dataStudio
    .map(async (studio) => {
      const sensorStudioUrl = `${sensorUrl}?studioId=${studio['@id']}`;

      const sensorValue = await callApi(`${sensorStudioUrl}&type=available_places`)
        .then(sensorResponse => sensorResponse['hydra:member']);

      const studioStatus = await callApi(`${sensorStudioUrl}&type=resabox_off`)
        .then(response => response['hydra:member']);

      return Object.assign({}, studio, { sensor: sensorValue, status: studioStatus });
    });

  return Promise.all(promises);
};


function componentWillMount() {
  getStudio({ params: { active: true } })
    .then(response => getDataWithSensor(response['hydra:member']))
    .then((studioSensorList) => {
      this.props.setStudioWithSensor(studioSensorList);
      this.props.setIsLoading(false);
    });
}

const enhance = compose(
  withState('studioWithSensor', 'setStudioWithSensor', []),
  withState('isLoading', 'setIsLoading', true),
  lifecycle({
    componentWillMount,
  }),
);

export default enhance(App);



// WEBPACK FOOTER //
// src/App/AppContainer.js